<template>
  <div
    class="chartTable"
    v-if="boxData.judgeBox"
    :style="{'top': boxData.fix.y+'px', 'left': boxData.fix.x+'px', 'z-index': boxData.Zindex, }"
    @mousedown="stopDocument($event)"
  >
    <div
      class="header"
      @mousedown="moveStart($event, true)"
      @mousemove="moveArea($event)"
      @mouseup="saveMoveState($event)"
      :style="{'cursor': 'move'}"
    >
      <span>编辑图表</span>
      <i @click="close" class="icon-popup-close"></i>
    </div>
    <div class="chartTable-container">
      <input class="chart-title" type="text" v-model="data.title" placeholder="图表标题" />
      <div class="table-container">
        <div class="pie-mask" v-show="chartType === 'pie' || chartType === 'PieChart'"></div>
        <table class="edit-table">
          <tbody>
            <tr>
              <td class="dark-td"></td>
              <td class="dark-td">
                <input v-model="data.legendItemLabels[0]" />
              </td>
              <td class="dark-td">
                <input v-model="data.legendItemLabels[1]" />
              </td>
              <td class="dark-td">
                <input v-model="data.legendItemLabels[2]" />
              </td>
              <td class="dark-td">
                <input v-model="data.legendItemLabels[3]" />
              </td>
            </tr>
            <tr>
              <td class="dark-td">
                <input v-model="data.groupLabels[0]" />
              </td>
              <td>
                <input v-model="data.data[0][0]" />
              </td>
              <td>
                <input v-model="data.data[1][0]" />
              </td>
              <td>
                <input v-model="data.data[2][0]" />
              </td>
              <td>
                <input v-model="data.data[3][0]" />
              </td>
            </tr>
            <tr>
              <td class="dark-td">
                <input v-model="data.groupLabels[1]" />
              </td>
              <td>
                <input v-model="data.data[0][1]" />
              </td>
              <td>
                <input v-model="data.data[1][1]" />
              </td>
              <td>
                <input v-model="data.data[2][1]" />
              </td>
              <td>
                <input v-model="data.data[3][1]" />
              </td>
            </tr>
            <tr>
              <td class="dark-td">
                <input v-model="data.groupLabels[2]" />
              </td>
              <td>
                <input v-model="data.data[0][2]" />
              </td>
              <td>
                <input v-model="data.data[1][2]" />
              </td>
              <td>
                <input v-model="data.data[2][2]" />
              </td>
              <td>
                <input v-model="data.data[3][2]" />
              </td>
            </tr>
            <tr>
              <td class="dark-td">
                <input v-model="data.groupLabels[3]" />
              </td>
              <td>
                <input v-model="data.data[0][3]" />
              </td>
              <td>
                <input v-model="data.data[1][3]" />
              </td>
              <td>
                <input v-model="data.data[2][3]" />
              </td>
              <td>
                <input v-model="data.data[3][3]" />
              </td>
            </tr>
            <tr>
              <td class="dark-td">
                <input v-model="data.groupLabels[4]" />
              </td>
              <td>
                <input v-model="data.data[0][4]" />
              </td>
              <td>
                <input v-model="data.data[1][4]" />
              </td>
              <td>
                <input v-model="data.data[2][4]" />
              </td>
              <td>
                <input v-model="data.data[3][4]" />
              </td>
            </tr>
            <tr>
              <td class="dark-td">
                <input v-model="data.groupLabels[5]" />
              </td>
              <td>
                <input v-model="data.data[0][5]" />
              </td>
              <td>
                <input v-model="data.data[1][5]" />
              </td>
              <td>
                <input v-model="data.data[2][5]" />
              </td>
              <td>
                <input v-model="data.data[3][5]" />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <p class="notice">点击确定后，数据才会更新至图表中。</p>
      <span class="btn" @click="insertChart">确定</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import popup from "../mixins/popup";
export default {
  mixins: [popup],
  data() {
    return {
      boxData: {
        judgeBox: false, // 控制盒子开启关闭
        Zindex: 0, // 盒子层级
        data: null, // 盒子数据
        moveoks: false, // 拖动判读啊数据
        oldMove: {
          // 计算移动增量
          x: 0,
          y: 0
        },
        fix: {
          // 弹窗位置
          x: 0,
          y: 0
        }
      },
      chartTitle: "",
      chartStyle: "simple",
      colors: [],
      chartType: "",
      id: Number,
      scenesId: Number,
      exists: false,
      originalChartType: "",
      chartOption: "",
      sprite: null,
      option: {},
      style: {},
      barStyle: {
        axisStyle: {
          valueMarkerFormat: {
            fontFamily: "Microsoft YaHei",
            fontSize: 14.0,
            foreground: "#424f61",
            isBold: false,
            thickness: {
              left: 0.0,
              top: 0.0,
              right: 14.0,
              bottom: 0.0
            }
          },
          valueMarkerLineLength: 2.0,
          lineWidth: 2.0,
          lineColor: "#424f61",
          dataAreaHeight: 288.0,
          topSpace: 22.0,
          rightSpace: 22.0,
          startOffset: 22.0,
          arrowWidth: 10.0,
          arrowHeight: 8.0
        },
        groupLabelFormat: {
          fontFamily: "Microsoft YaHei",
          fontSize: 14.0,
          foreground: "#424f61",
          isBold: false,
          thickness: {
            left: 0.0,
            top: 12.0,
            right: 0.0,
            bottom: 0.0
          }
        },
        barBorderWidth: 2.0,
        barBorderColor: "#424f61",
        barMaxWidth: 86.0,
        barMinWidth: 20.0,
        barMaxNumber: 4,
        groupSpace: 30.0,
        barSpace: 2.0,
        chartType: 0,
        titleFormat: {
          fontFamily: "Microsoft YaHei",
          fontSize: 18.0,
          foreground: "#424f61",
          isBold: false,
          thickness: {
            left: 0.0,
            top: 0.0,
            right: 0.0,
            bottom: 30.0
          }
        },
        dataLabelFormat: {
          fontFamily: "Microsoft YaHei",
          fontSize: 10.0,
          foreground: "#424f61",
          isBold: false,
          thickness: {
            left: 0.0,
            top: 4.0,
            right: 0.0,
            bottom: 0.0
          }
        },
        legendStyle: {
          colorBlockWidth: 8.0,
          colorBlockHeight: 8.0,
          labelFormat: {
            fontFamily: "Microsoft YaHei",
            fontSize: 14.0,
            foreground: "#424f61",
            isBold: false,
            thickness: {
              left: 4.0,
              top: 0.0,
              right: 20.0,
              bottom: 20.0
            }
          },
          thickness: {
            left: 14.0,
            top: 46.0,
            right: 0.0,
            bottom: 0.0
          }
        },
        colorSpace: [
          "#f9f9f9",
          "#bebebe",
          "#f6cb78",
          "#9cd5ff",
          "#dddddd",
          "#6a6a6a"
        ]
      },
      lineStyle: {
        axisStyle: {
          valueMarkerFormat: {
            fontFamily: "Microsoft YaHei",
            fontSize: 14.0,
            foreground: "#424f61",
            isBold: false,
            thickness: {
              left: 0.0,
              top: 0.0,
              right: 14.0,
              bottom: 0.0
            }
          },
          valueMarkerLineLength: 2.0,
          lineWidth: 2.0,
          lineColor: "#424f61",
          dataAreaHeight: 288.0,
          topSpace: 22.0,
          rightSpace: 22.0,
          startOffset: 22.0,
          arrowWidth: 10.0,
          arrowHeight: 8.0
        },
        groupLabelFormat: {
          fontFamily: "Microsoft YaHei",
          fontSize: 14.0,
          foreground: "#424f61",
          isBold: false,
          thickness: {
            left: 0.0,
            top: 12.0,
            right: 0.0,
            bottom: 0.0
          }
        },
        dataAreaWidth: 580.0,
        lineWidth: 2.0,
        dotSizeWidth: 8.0,
        dotSizeHeight: 8.0,
        dotShape: 0,
        chartType: 2,
        titleFormat: {
          fontFamily: "Microsoft YaHei",
          fontSize: 18.0,
          foreground: "#424f61",
          isBold: false,
          thickness: {
            left: 0.0,
            top: 0.0,
            right: 0.0,
            bottom: 30.0
          }
        },
        dataLabelFormat: {
          fontFamily: "Microsoft YaHei",
          fontSize: 10.0,
          foreground: "#424f61",
          isBold: false,
          thickness: {
            left: 0.0,
            top: 4.0,
            right: 0.0,
            bottom: 0.0
          }
        },
        legendStyle: {
          colorBlockWidth: 8.0,
          colorBlockHeight: 8.0,
          labelFormat: {
            fontFamily: "Microsoft YaHei",
            fontSize: 14.0,
            foreground: "#424f61",
            isBold: false,
            thickness: {
              left: 4.0,
              top: 0.0,
              right: 20.0,
              bottom: 20.0
            }
          },
          thickness: {
            left: 14.0,
            top: 46.0,
            right: 0.0,
            bottom: 0.0
          }
        },
        colorSpace: [
          "#d0d0d0",
          "#ffc773",
          "#abde64",
          "#c9f4f3",
          "#64b3d5",
          "#e86a57"
        ]
      },
      pieStyle: {
        radius: 144.0,
        borderWidth: 2.0,
        borderColor: "#ffffff",
        chartType: 1,
        titleFormat: {
          fontFamily: "Microsoft YaHei",
          fontSize: 18.0,
          foreground: "#424f61",
          isBold: false,
          thickness: {
            left: 0.0,
            top: 0.0,
            right: 0.0,
            bottom: 30.0
          }
        },
        dataLabelFormat: {
          fontFamily: "Microsoft YaHei",
          fontSize: 10.0,
          foreground: "#424f61",
          isBold: false,
          thickness: {
            left: 0.0,
            top: 48.0,
            right: 0.0,
            bottom: 0.0
          }
        },
        legendStyle: {
          colorBlockWidth: 8.0,
          colorBlockHeight: 8.0,
          labelFormat: {
            fontFamily: "Microsoft YaHei",
            fontSize: 14.0,
            foreground: "#424f61",
            isBold: false,
            thickness: {
              left: 4.0,
              top: 0.0,
              right: 20.0,
              bottom: 20.0
            }
          },
          thickness: {
            left: 20.0,
            top: 22.0,
            right: 0.0,
            bottom: 0.0
          }
        },
        colorSpace: [
          "#d0d0d0",
          "#ffc773",
          "#abde64",
          "#c9f4f3",
          "#64b3d5",
          "#e86a57"
        ]
      },
      data: {
        title: "",
        groupLabels: ["类别1", "类别2", "类别3", "类别4", "类别5", "类别6"],
        legendItemLabels: ["系列1", "系列2", "系列3", "系列4"],
        data: [
          [, , , , , ,],
          [, , , , , ,],
          [, , , , , ,],
          [, , , , , ,]
        ],
        legendPosition: 0,
        isShowTitle: true,
        isShowGroupLabels: true,
        isShowLegend: true,
        isShowDataValues: true
      }
    };
  },
  props: ["dataMsg", "boxDatas"],
  computed: {
    ...mapGetters([
      "TOOL",
      "MaterialPane_Size",
      "Tool_Size",
      "TopNav_Size",
      "StyleMsg",
      "SpriteOperation",
      "SelectSprites_Msg"
    ])
  },
  watch: {
    "boxDatas.firstDatas": function(val, oldval) {
      // 判断打开关闭
      let num = Array.indexOf(this.boxDatas.firstDatas, "edit_Chart");
      this.boxData.judgeBox = num < 0 ? false : true; // 判断是否打开

      if (this.TOOL && this.boxData.judgeBox) {
        // 打开的操作
        this.$store.commit("toggle_isPreventDefault", false);
        this.boxData.data = this.dataMsg.edit_Chart;
        this.sprite = this.boxData.data.sprite || null;
        this.boxData.Zindex = (this.dataMsg.length + 1) * 5;
        this.boxData.fix.x = 20;
        this.boxData.fix.y =
          this.TopNav_Size.height + this.Tool_Size.height / 2;
        this.chartType = this.dataMsg.edit_Chart.sprite.chartOption.series[0].type;
      }
    },
    "boxData.judgeBox"(val) {
      if (val) {
        // 先用静态json代替data
        if (this.sprite) {
          this.exists = true;
          this.id = this.sprite.id;
          this.scenesId = this.sprite.scenesId;
          this.option = JSON.parse(JSON.stringify(this.sprite.option));
          // this.data = Object.assign({}, this.option.data);
          // 深拷贝
          this.data = JSON.parse(JSON.stringify(this.option.data));
          this.chartType = this.option.chartOption.series[0].type;
          switch (this.chartType) {
            case "bar":
              this.style = Object.assign(this.barStyle, this.option.style);
              break;
            case "line":
              this.style = Object.assign(this.lineStyle, this.option.style);
              break;
            case "pie":
              this.style = Object.assign(this.pieStyle, this.option.style);
              break;
          }
        } else {
          // 显示空表
          this.init();
          switch (this.chartType) {
            case "bar":
              this.data.data = [
                [15, 20, 36, , , ,],
                [20, 25, 56, , , ,],
                [, , , , , ,],
                [, , , , , ,]
              ];
              this.style = this.barStyle;
              break;
            case "line":
              this.data.data = [
                [15, 20, 36, , , ,],
                [20, 25, 56, , , ,],
                [, , , , , ,],
                [, , , , , ,]
              ];
              this.style = this.lineStyle;
              break;
            case "pie":
              this.data.data = [
                [10, 20, 30, 40, , ,],
                [, , , , , ,],
                [, , , , , ,],
                [, , , , , ,]
              ];
              this.style = this.pieStyle;
              break;
          }
          this.exists = false;
        }
      } else {
        this.$store.commit("toggle_isPreventDefault", true);
      }
    },
    "data.data": {
      deep: true,
      handler(val) {
        for (let i = 0; i < 4; i++) {
          for (let j = 0; j < 6; j++) {
            if (!Number(val[i][j]) && Number(val[i][j]) !== 0) {
              val[i][j] = "";
            }
          }
        }
      }
    }
  },
  mounted() {
    this.$bus.on("Document_mousemove_vue", event => {
      let e = event ? event : window.event;
      if (this.boxData.moveoks) {
        this.moveArea(e);
        return false;
      }
    });
    this.$bus.on("Document_mouseup_vue", event => {
      let e = event ? event : window.event;
      if (this.boxData.moveoks) {
        this.saveMoveState(e);
        return false;
      }
    });
    this.$bus.on("FeaturesPop_close_vue", data => {
      if (data.name === "edit_Chart") {
        this.$store.commit("toggle_isPreventDefault", true);
      }
    });
  },
  methods: {
    close() {
      if (!this.boxData.judgeBox) return;
      this.$bus.emit("FeaturesPop_close_vue", {
        name: "edit_Chart",
        type: 1
      });
    },
    init() {
      this.data.title = "";
      this.data.groupLabels = [
        "类别1",
        "类别2",
        "类别3",
        "类别4",
        "类别5",
        "类别6"
      ];
      this.data.legendItemLabels = ["系列1", "系列2", "系列3", "系列4"];
      this.data.data = [
        [, , , , , ,],
        [, , , , , ,],
        [, , , , , ,],
        [, , , , , ,]
      ];
      this.option = {};
      switch (this.StyleMsg) {
        case 1:
          this.colors = this.simple.colors;
          break;
        case 2:
          this.colors = this.blackWhite.colors;
          break;
        case 3:
          this.colors = this.cute.colors;
          break;
        default:
          this.colors = this.business.colors;
          break;
      }
    },
    isArrayEmpty(arr) {
      var num = 0;
      if (arr) {
        arr.forEach(item => {
          if (parseFloat(item) >= 0) {
            num++;
          }
        });
      }
      return num === 0;
    },
    insertChart() {
      this.visible = false;
      // this.option.chartType = this.chartType.substring(0, 1).toUpperCase() + this.chartType.substring(1) + 'Chart';
      this.option.style = Object.assign({}, this.style);
      // this.option.data = Object.assign({}, this.data);
      // 处理空单元格
      let maxI = 0,
        maxJ = 0;
      for (let i = 3; i >= 0; i--) {
        if (this.isArrayEmpty(this.data.data[i])) continue;
        maxI = Math.max(maxI, i);
        for (let j = 5; j >= 0; j--) {
          if (parseFloat(this.data.data[i][j]) >= 0) {
            maxJ = Math.max(maxJ, j);
          }
        }
      }
      for (let i = 0; i < maxI + 1; i++) {
        for (let j = 0; j < maxJ + 1; j++) {
          if (!this.data.data[i][j]) {
            this.data.data[i][j] = 0;
          }
        }
      }
      this.option.data = JSON.parse(JSON.stringify(this.data));
      this.option.chartOption = Object.assign(
        {},
        this.$chartFromJson(this.option)
      );
      this.TOOL.updateSprite(this.id, this.option, this.scenesId, true);

      if (this.SpriteOperation === "swap") {
        this.TOOL.swapSprite({
          sprite: this.SelectSprites_Msg[0],
          typeForAdd: "Chart",
          optionForAdd: {
            chartOption: this.option.chartOption,
            style: this.option.style,
            data: this.option.data
          }
        });
      }
    },
    stopDocument(e) {
      // 防止事件冒泡
      e.stopPropagation();
    }
  }
};
</script>

<style lang="scss" scoped>
.chartTable {
  position: fixed;
  top: 0;
  left: 0;
  width: 430px;
  height: 420px;
  z-index: 35;
  border: 1px solid #d8dee9;
  background: #fff;
  font-family: "Microsoft YaHei";
  font-size: 14px;
  color: #474261;
  overflow: hidden;
  box-shadow: 0px 0px 4px 0px rgba(54, 76, 204, 0.4);
  border-radius: 4px;
  box-sizing: border-box;
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 12px 0 15px;
    height: 34px;
    background-color: #d8dee9;
    span {
      color: #474261;
    }
    i {
      display: inline-block;
      width: 12px;
      height: 12px;
      cursor: pointer;
    }
  }
  .chartTable-container {
    width: 430px;
    height: 386px;
    padding: 10px 10px;
    background-color: #fff;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    .chart-title {
      width: 100%;
      height: 36px;
      padding: 12px 16px 10px;
      margin-bottom: 9px;
      background-color: #f6f6fc;
      border: 1px solid #9692a9;
      &:focus {
        border: 1px solid #409eff;
        border-radius: 3px;
        box-shadow: 0 0 1px 1px #409eff;
      }
    }
    .table-container {
      position: relative;
      width: 412px;
      height: 234px;
      overflow: scroll;
      &::-webkit-scrollbar {
        width: 0px;
        height: 10px;
        background-color: transparent;
      }
      &::-webkit-scrollbar-track {
        // background-color: transparent;
        display: none;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 20px;
        width: 7px;
        background: rgba(87, 120, 251, 0.2);
        &:hover {
          background: rgba(87, 120, 251, 0.6);
        }
      }
      &::-webkit-scrollbar-button:start {
        display: none;
      }
      &::-webkit-scrollbar-button:end {
        display: none;
      }
      .pie-mask {
        position: absolute;
        top: 3px;
        right: -114px;
        width: 321px;
        height: 264px;
        background-color: #fff;
        opacity: 0.6;
      }
      table.edit-table {
        width: 512px;
        height: 270px;
        border: 1px solid gray;
        border-collapse: collapse;
        input {
          text-align: center;
          border: none;
          outline: none;
          width: 100%;
          height: 100%;
          background: transparent;
          &:focus {
            border: 1px solid #409eff;
            border-radius: 3px;
            box-shadow: 0 0 1px 1px #409eff;
          }
        }
        .dark-td {
          background-color: #e4e4f0;
        }
        th {
          width: 100px;
          height: 36px;
          border: 1px solid gray;
        }
        tbody {
          tr {
            td {
              width: 100px;
              height: 36px;
              background-color: #f6f6fc;
              border: 3px solid #fff;
            }
          }
        }
      }
    }
    .notice {
      width: 100%;
      text-align: left;
      margin: 12px 0;
    }
    .btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 120px;
      height: 36px;
      color: #fff;
      background-color: #5778fb;
      border-radius: 8px;
      border: none;
      cursor: pointer;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/popups/chartTable.vue